import { INavItemProps } from 'components/atoms/NavItem'
import NavItems from 'components/atoms/NavItems'
import React from 'react'
import styled from 'styled-components'
import I18n from '../../core/i18n'
import { userService } from '../../core/services'
import * as constants from '../../static/constants'
import LocaleSelect from '../atoms/LocaleSelect'

interface IProps {
  active: string
  lang?: any
  user: any
  backgroundColor?: 'default' | 'white'
}

const getUserNavItemList: (user: any, active: string) => INavItemProps[] = (user, active) => {
  if (user.guest) {
    return [
      {
        label: I18n.t('generic.accounts'),
        active: active === 'account',
        href: '/settings',
        iconName: 'account_circle',
      },
      {
        label: I18n.t('generic.profile'),
        active: active === 'profile',
        href: '/settings/profile',
        iconName: 'face',
      },
      {
        label: I18n.t('generic.notification'),
        active: active === 'notification',
        href: '/settings/notification',
        iconName: 'notifications',
      },
      {
        label: I18n.t('generic.card'),
        active: active === 'card',
        href: '/settings/card',
        iconName: 'payment',
      },
    ]
  }
  if (user.guide) {
    return [
      { label: I18n.t('generic.accounts'), active: active === 'account', href: '/settings' },
      { label: I18n.t('generic.profile'), active: active === 'profile', href: '/settings/profile' },
      {
        label: I18n.t('generic.notification'),
        active: active === 'notification',
        href: '/settings/notification',
      },
      {
        label: I18n.t('generic.identification'),
        active: active === 'identification',
        href: '/settings/identification',
      },
    ]
  }
  if (user.agent) {
    return [
      { label: I18n.t('generic.accounts'), active: active === 'account', href: '/settings' },
      { label: I18n.t('generic.profile'), active: active === 'profile', href: '/settings/profile' },
      {
        label: I18n.t('generic.notification'),
        active: active === 'notification',
        href: '/settings/notification',
      },
      {
        label: I18n.t('generic.identification'),
        active: active === 'identification',
        href: '/settings/identification',
      },
    ]
  }
  if (user.admin) {
    return [
      { label: I18n.t('generic.accounts'), active: active === 'account', href: '/settings' },
      { label: I18n.t('generic.profile'), active: active === 'profile', href: '/settings/profile' },
      {
        label: I18n.t('generic.notification'),
        active: active === 'notification',
        href: '/settings/notification',
      },
    ]
  }
  return []
}

const SettingsNav: React.FC<IProps> = props => {
  const { user } = userService.getUserFromJson(props.user)
  return (
    <SettingsNavWrapper className="SettingsNav" backgroundColor={props.backgroundColor}>
      <NavItems navItemArray={getUserNavItemList(user, props.active)} />
      {props.lang && <LocaleSelect />}
    </SettingsNavWrapper>
  )
}

const SettingsNavWrapper = styled.div`
  width: 280px;
  height: calc(100vh - ${constants.HEADER_HEIGHT + constants.FOOTER_HEIGHT}px);
  /* box-shadow: 0 1px 3px 0 rgba(21, 27, 38, 0.1); */
  z-index: 1000;
  padding-top: 20px;
  background-color: ${({ backgroundColor }) =>
    backgroundColor === 'white' ? constants.COLORS.white : constants.COLORS.background};
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    padding-top: 0;
    width: 100%;
    height: 40px;
    overflow: auto;
    white-space: nowrap;
    border-bottom: solid 1px ${constants.COLORS.divider2};
  }

  .Nav_List {
    padding: 16px 0;

    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      height: inherit;
      padding: 0;
      display: flex;
    }

    li {
      padding: 8px 20px;
      cursor: pointer;
      font-size: 14px;

      @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
        padding: 0 16px;
        display: flex;
        flex-shrink: 0;
        align-items: center;
      }

      > a {
        display: block;
        text-decoration: none;
        color: ${constants.COLORS.black};
      }

      > .Button {
        width: 100%;
        text-align: center;

        @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
          height: 30px;
          padding: 0 12px;
        }

        a {
          justify-content: center;
        }
      }

      &.active {
        border-right: solid 3px ${constants.COLORS.primary};
        color: ${constants.COLORS.primary};
        font-weight: bold;

        > a {
          color: inherit;
          font-weight: inherit;
        }

        @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
          border-right: none;
          border-bottom: solid 2px ${constants.COLORS.primary};
        }
      }

      &.disabled {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
      }

      &:hover:not(.active):not(.disabled) {
        color: ${constants.COLORS.primary};
      }
    }
  }

  .Nav_Buttons {
    padding: 8px 20px;
  }
`

export default SettingsNav
